import React, { useRef } from "react";
import html2pdf from "html2pdf.js";
import "./StudentStrengthReportPdfStyles.css";
import logo from "../../assets/img/logo-full.png";
import studentImage from "../../assets/img/generic/student-girl.jpg";

const StudentStrengthReportPdfGenerator = ({ reportData }) => {
  const pdfRef = useRef();

  const generatePdf = () => {
    const element = pdfRef.current;

    // Configure PDF options
    const options = {
      margin: 0.2,
      filename: "student-strength-report.pdf",
      image: { type: "jpeg", quality: 1 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
    };

    // Generate PDF
    html2pdf()
      .set(options)
      .from(element)
      .outputPdf("blob") // Output the PDF as a blob
      .then((pdfBlob) => {
        // Create a URL for the Blob
        const pdfUrl = URL.createObjectURL(pdfBlob);

        // Open the PDF in a new tab
        window.open(pdfUrl, "_blank");
      });
  };

  // console.log(reportData);
  // return;

  // const reportData = [
  //   {
  //     centerName: "Center 1",
  //     classesAndStrength: [
  //       {
  //         className: "Class 1",
  //         strength: "50",
  //       },
  //       {
  //         className: "Class 1",
  //         strength: "50",
  //       },
  //     ],
  //   },
  // ];

  return (
    <>
      <div className="pdf-content">
        <div className="d-flex">
          <button
            onClick={generatePdf}
            className="btn btn-danger btn-sm mb-3 ms-auto"
          >
            Open PDF
          </button>
        </div>
        <div ref={pdfRef}>
          <div className="row mb-3">
            <div className="col-2">
              <img
                src={logo}
                alt="logo"
                style={{ height: "25px", width: "auto" }}
              />
              {/* <p>{reportData.organizationName}</p> */}
            </div>
            <div className="col-8 text-center">
              <h5 className="mb-2">Pupil Strength Report</h5>
              {/* <h5>
                {reportData.studentName} - {reportData.classSection}
              </h5>
              <h6>{reportData.termName}</h6> */}
            </div>
            <div className="col-2 text-end d-none">
              {/* <div className="student-picture">
                <img src={studentImage} alt="student-picture" />
              </div> */}
            </div>
          </div>

          {reportData.map((item, itemIndex) => (
            <table
              className="table custom-table table-bordered"
              key={itemIndex}
            >
              <thead>
                <tr>
                  <th colSpan={3} className="text-center">
                    {item.centerName}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>Year Group</th>
                  <th>Section</th>
                  <th>Strength</th>
                </tr>
                {item.studentClassWiseCountDto.map(
                  (innerItem, innerItemIndex) => (
                    <tr key={innerItemIndex}>
                      <td>{innerItem.className}</td>
                      <td>{innerItem.sectionName}</td>
                      <td>{innerItem.studentStrength}</td>
                    </tr>
                  )
                )}
              </tbody>
            </table>
          ))}
        </div>
      </div>
    </>
  );
};

export default StudentStrengthReportPdfGenerator;
